// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1eE0s","row":"ProcedureTreatmentSummary_row__1G6iQ"};